module.exports = __webpack_public_path__ + "img/1442591634.8c14b070.jpg";